import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({
  publishing: false,
  savingPreview: false,
  previewSaved: false,
  previewSavingError: null,
  showSharing: false,
  previewTimeStamp: null,
  previewSrc: null,
  logoSrc: null
});

const exportReducer = createReducer(getDefaultState(), {
  [Constants.export.publishing]: (state) => ({
    ...state,
    publishing: true
  }),
  [Constants.export.published]: (state) => ({
    ...state,
    publishing: false
  }),
  [Constants.export.savePreview]: (state) => ({
    ...state,
    savingPreview: true,
    previewSaved: false,
    previewSavingError: null,
    showSharing: false,
    previewTimeStamp: null,
    previewSrc: null
  }),
  [Constants.export.previewSaved]: (state, { error, previewTimeStamp, previewSrc }) => ({
    ...state,
    savingPreview: false,
    previewSaved: !error,
    previewSavingError: error,
    previewTimeStamp,
    previewSrc
  }),
  [Constants.export.showSharing]: (state) => ({
    ...state,
    showSharing: true
  }),
  [Constants.export.setLogo]: (state, { logoSrc }) => ({
    ...state,
    logoSrc
  }),
  [Constants.canvas.setColor]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.canvas.remove]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.canvas.move]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.canvas.add]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.canvas.setFrame]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.wallPaper.add]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.wallPaper.update]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.wallPaper.remove]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.customImage.update]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.customImage.add]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.customImage.remove]: (state) => ({
    ...state,
    previewSrc: null
  }),
  [Constants.customImage.move]: (state) => ({
    ...state,
    previewSrc: null
  })
});

export default exportReducer;
